<script setup lang="ts">
import GlobalData from "@/GlobalData";
import auth from "@/auth";
import { useAuthenticationStore } from "@/stores/authentication";
import { useRouter } from "vue-router";
import { useAudit } from "@/stores/audit";


const router = useRouter();

const authenticationStore = useAuthenticationStore();
const audit = useAudit();
auth
  .signinCallback()
  .then((user) => {
    useAuthenticationStore().setUser(user || null);
    authenticationStore.decodeJwt();
    audit.auditLog("Login");
    if (useAuthenticationStore().userRole == 1) {
      router.push({ name: "admin" });
    } else {
      router.push({ name: "content" });
    }
  })
  .catch((error) => {
    GlobalData.getInstance().errorMessage.setErrorStatus(404);
    GlobalData.getInstance().hasErrorPage = true;
    router.push({ name: "error" });
  });
</script>

<template></template>
